import React, { ReactElement } from "react";
import { Trans } from "react-i18next";
import { Eexi } from "../Decarbonisation/Eexi";
import { Cii } from "../Decarbonisation/Cii";
import "./Summary.css";
import { SummaryProps } from "../../types/SummaryProps";

export const Summary = (props: SummaryProps): ReactElement => {
    const getLocaleValue = (i18nKey: string) => {
        return <Trans ns="common" i18nKey={i18nKey} />;
    };

    const getSummaryText = () => {
        const summaryParagraph = props.summaryData.paragraph?.trim();
        const summaryText =
            summaryParagraph ||
            getLocaleValue("inspectionReport.summary.noSummary");

        return <p className="summary">{summaryText}</p>;
    };

    let summary = <div className="col-12 lg:col-6 ">{getSummaryText()}</div>;

    if (!props.summaryData.eexiData || !props.showDecarbonisation) {
        summary = <div className="col-12">{getSummaryText()}</div>;

        return (
            <div className="format_text grid" style={{ maxWidth: "58rem" }}>
                {summary}
            </div>
        );
    }

    const decarbItems: JSX.Element[] = [];
    decarbItems.push(
        <div className="col p-1 pb-3">
            <div className={"decarb_summary_title"}>
                {getLocaleValue("inspectionReport.summary.decarb_title")}
            </div>

            <div className={"decarb_summary_line"}></div>
        </div>
    );

    if (props.summaryData.eexiData) {
        decarbItems.push(<Eexi eexiData={props.summaryData.eexiData} />);
    }

    if (props.summaryData.ciiData) {
        decarbItems.push(<Cii ciiData={props.summaryData.ciiData} />);
    }

    return (
        <div className="grid">
            {summary}
            {props.showDecarbonisation && (
                <div className="col-12 lg:col-6">
                    <div>{decarbItems}</div>
                </div>
            )}
        </div>
    );
};
